import commonObj from "../../../../services/common.js";
import { HTTP } from "../../../../services/api-service.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "CurrencyRate";

const currencyRateStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "CurrencyCode,asc",
      //orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0
  },
  actions: {
    
    getAllCurRate({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        state.q.searchCriteria="";
        HTTP.post(baseUrl + "/qgl/listvalue", state.q).then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveCurrencyRate({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableName,
            modelList: param.curRateModel,
            option: param.option
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
  }
};
export default currencyRateStore;
